import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/splitButton';

@Component({
  templateUrl: './splitButton.component.html'
})
export class SplitButtonComponent implements OnInit {
	code = Code;
	parameters: any[];
	eventHeader: any[];
	eventValue: any[];
	styleHeader: any[];
	styleValue: any[];
	items: any[]; 
	headers: any[];
  constructor() { }

  ngOnInit() {
  	this.items = [
        {label: 'Update', icon: 'fa ion-refresh', command: () => {
            console.log(1)
        }},
        {label: 'Delete', icon: 'fa ion-close', command: () => {
            console.log(2)
        }},
        {label: 'Angular.io', icon: 'fa-link', url: 'http://angular.io'},
        {label: 'Theming', icon: 'fa-paint-brush', routerLink: ['/theming']}
    ];
  	this.parameters = [
        {name: "label",type: "string",default: "null",des: "按钮的文字显示"},
        {name: "icon",type: "string",default: "null",des: "图标名字"},
        {name: "iconPos",type: "string",default: "left",des: "图标的位置,左边和右边"},
        {name: "style",type: "string",default: "null",des: "组件行内样式"},
        {name: "styleClass",type: "string",default: "null",des: "组件class样式"},
        {name: "menuStyle",type: "string",default: "null",des: "覆盖菜单的行内样式"},
        {name: "menuStyleClass",type: "string",default: "null",des: "覆盖菜单的class样式"},
        {name: "appendTo",type: "any",default: "null",des: "目标元素被覆盖,有效值是“body”或0ng-template变量的另一个元素。"},
        {name: "disabled",type: "boolean",default: "false ",des: "目标元素被覆盖,有效值是“body”或0ng-template变量的另一个元素。"},
        {name: "tabindex",type: "number",default: "null ",des: "列表中元素索引"},
        {name: "dir",type: "string",default: "null ",des: "指示元素的方向"}
    ];
    
    this.headers = [
        {name : "名字"},
        {name : "类型"},
        {name : "默认"},
        {name : "描述"}
    ];

    this.eventHeader = [
    	{name : "名字"},
        {name : "参数"},
        {name : "描述"}
    ];

    this.eventValue = [
    	{name : "onClick",param : "事件：浏览器事件",event :"默认点击按钮时回调onClick事件" },
        {name : "onDropdownClick",param : "事件：浏览器事件",event :"当下拉按钮被点击的时候调用onDropdownClick事件" }
    ];

    this.styleHeader = [
    	{name : "名字"},
        {name : "元素"}
    ];

    this.styleValue = [
    	{name : "ui-splitbutton",el : "容器元素"},
    	{name : "ui-splitbutton-button",el : "下拉按钮"},
    	{name : "ui-menu",el : "覆盖菜单"},
    ];
  }

}



// WEBPACK FOOTER //
// ./src/app/view/splitButton/splitButton.component.ts